import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  hideBackground: PropTypes.bool,
  isRound: PropTypes.bool
};

const defaultProps = {
  hideBackground: false,
  isRound: false
};

function YellowPages(props) {
  const { hideBackground, isRound, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      {!hideBackground && <rect fill="#231F20" height="24" rx={isRound ? '100%' : 0} width="24" />}
      <path clipRule="evenodd" d="M6 16.6698H17.8935V15.426H6V16.6698Z" fill="#FFE500" fillRule="evenodd" />
      <path
        clipRule="evenodd"
        d="M17.9998 7.3241V7.73103H17.9474L17.9547 7.38986L17.8288 7.73103H17.7877L17.6641 7.39499L17.6698 7.73103H17.6178V7.3241H17.6861L17.8086 7.6579L17.9317 7.3241H17.9998ZM17.3831 7.54322C17.3255 7.53099 17.241 7.51139 17.241 7.42722C17.241 7.3869 17.2623 7.36159 17.2776 7.3483C17.3131 7.31726 17.3567 7.31378 17.3843 7.31378C17.4125 7.31378 17.4554 7.3166 17.4915 7.3437C17.5311 7.37309 17.539 7.41459 17.5428 7.43945L17.4892 7.44293C17.4886 7.43024 17.4869 7.39795 17.457 7.37553C17.4367 7.36047 17.4114 7.35586 17.386 7.35586C17.3381 7.35586 17.2958 7.37599 17.2958 7.41978C17.2958 7.46477 17.3397 7.47516 17.3743 7.48325L17.4182 7.49475C17.4486 7.50218 17.4649 7.50574 17.4809 7.51264C17.5408 7.53796 17.5496 7.58702 17.5496 7.61405C17.5496 7.65206 17.5345 7.68783 17.4988 7.71262C17.4604 7.73906 17.4148 7.74143 17.3905 7.74143C17.3545 7.74143 17.2308 7.73557 17.2218 7.60142L17.2787 7.59386C17.2794 7.60951 17.2811 7.64509 17.3111 7.67225C17.3334 7.69237 17.3635 7.69934 17.3928 7.69934C17.4491 7.69934 17.492 7.67119 17.492 7.61806C17.492 7.57077 17.4554 7.55808 17.4165 7.54999L17.3831 7.54322ZM16.0834 10.1769C16.0725 9.35682 15.7047 8.45759 14.6932 8.45759C13.6811 8.45759 13.3136 9.35682 13.3021 10.1769C13.3136 10.9968 13.6811 11.8962 14.6932 11.8962C15.7047 11.8962 16.0725 10.9968 16.0834 10.1769ZM12.004 7.33391H13.3457V7.81739H13.368C13.7746 7.43564 14.3625 7.19995 15.0221 7.19995C16.4305 7.19995 17.4908 8.5365 17.4908 10.1769C17.4908 11.6866 16.6197 13.1546 14.8665 13.1546C14.1637 13.1546 13.5945 12.9017 13.3457 12.5902V14.8389H12.004V7.33391ZM9.49585 13.5259C9.13172 14.5694 8.65216 14.9078 7.68506 14.9078C7.3546 14.9078 7.02466 14.8415 6.72909 14.7209V13.4962C6.94 13.5833 7.25874 13.672 7.57845 13.672C8.00753 13.672 8.18902 13.4492 8.18902 13.1651C8.18902 13.0536 8.14884 12.9379 8.06097 12.7091C7.97431 12.4796 6 7.33388 6 7.33388H7.46379L8.88946 11.6533H8.90768L10.1736 7.33388H11.5747L9.49585 13.5259Z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  );
}

YellowPages.propTypes = propTypes;
YellowPages.defaultProps = defaultProps;

export default YellowPages;
